import controller from './menu-dropdown.controller';
import templateBase from './templates/menu-dropdown-base.view.html';
import templateT3 from './templates/template_t3.view.html';

let MenuDropdownComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    menu : '<'
  }
};



changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');

    if (response.MENUDROPDOWN.component == 'template_t3') {
        return templateT3;
    }else{
        return templateBase;
    }
}

export default MenuDropdownComponent;



// WEBPACK FOOTER //
// ./www/components/shared/components/menu-dropdown/menu-dropdown.component.js